<template>
  <v-container
    :style="this.$vuetify.breakpoint.smAndDown ? '' : 'width: 870px;'"
  >
    <div id="booking">
      <!-- <div
        class="mx-auto mb-10 text-subtitle-2"
        align="center"
        justify="center"
      >
        <tr align="center">
          Velkommen til vores nye bookingportal.
        </tr>
        <tr align="center">
          Vi har gjort layoutet mere simpelt og brugervenligt, så det er lettere
          at booke kørsel med GLS Express.
        </tr>
        <tr align="center">
          Du får bl.a. nemmere adgang til live tracking og historikken giver et
          bedre overblik over dine bestillinger.
        </tr>
        <tr align="center">
          Vi håber, at du bliver glad for den nye portal.
        </tr>
      </div> -->

      <v-form ref="form">
        <BookingFlow class="mt-1" />
        <BookingAccount class="mt-1" />
        <BookingPickupDelivery class="mt-6" />
        <BookingGoodsOverview class="mt-6" />
        <BookingVehicleType class="mt-6" />
        <BookingTimewindow class="mt-6" />
        <BookingExtraInfo class="mt-6" />
      </v-form>
      <BookingPrice class="mt-6" />
      <v-card-actions class="mt-4">
        <v-spacer />
        <v-btn
          v-if="allowUploadBookingExcel"
          text
          class="text-right"
          @click="downloadBookingExcelTemplate()"
        >
          Hent Excel skabelon
        </v-btn>
        <v-btn
          v-if="allowUploadBookingExcel"
          text
          class="text-right"
          @click="showUploadBookingExcel = true"
        >
          Importer Excel
        </v-btn>
        <v-btn
          class="text-right"
          @click="validate()"
          height="40px"
          width="150px"
        >
          Send booking
        </v-btn>
      </v-card-actions>
    </div>
    <ConfirmSendDialog
      :display="confirmSendDialog"
      title="Send booking?"
      question="Vil du sende booking til GLS Express A/S?"
      rejectText="Nej tak"
      acceptText="Ja tak"
      @accepted="submit()"
      @rejected="confirmSendDialog = false"
    />
    <SendResultDialog
      :display="sendResultDialog"
      :title="sendResultTitle"
      :question="sendResultText"
      :disableReject="true"
      acceptText="Ok"
      @accepted="sendResultDialog = false"
      @rejected="sendResultDialog = false"
    />
    <ErrorDialog
      :display="showErrors"
      title="Oplysninger mangler"
      question="Udfyld formularen korrekt!"
      :questionDetails="errors"
      :disableReject="true"
      acceptText="Ok"
      @accepted="showErrors = false"
      @rejected="showErrors = false"
    />
    <UploadBookingExcelDialog
      :display="showUploadBookingExcel"
      title="Vælg Excel-fil"
      description="Vælg Excel-fil med ordre."
      filetype=".xlsx"
      @accepted="uploadBookingExcel"
      @rejected="showUploadBookingExcel = false"
    />
    <UploadBookingExcelErrorDialog
      :display="showUploadBookingExcelErrorDialog"
      title="Data kunne ikke indlæses"
      question="Benyt Excel skabelon!"
      :questionDetails="uploadBookingExcelErrors"
      :disableReject="true"
      acceptText="Ok"
      @accepted="showUploadBookingExcelErrorDialog = false"
      @rejected="showUploadBookingExcelErrorDialog = false"
    />
    <ConfirmUploadBookingExcelDialog
      :display="showConfirmUploadBookingExcelDialog"
      title="Importer Excel?"
      :question="confirmUploadBookingExcelQuestion"
      rejectText="Nej tak"
      acceptText="Ja tak"
      @accepted="handleBookingExcel"
      @rejected="
        showConfirmUploadBookingExcelDialog = false;
        confirmUploadBookingExcelQuestion = '';
        excelJSON = [];
      "
    />
    <v-overlay :value="loadProgress < 100">
      <v-progress-circular
        :rotate="-90"
        :size="100"
        :width="15"
        :value="loadProgress"
        color="primary"
        >{{ loadProgress }}%</v-progress-circular
      >
    </v-overlay>
  </v-container>
</template>

<script lang="javascript" src="dist/xlsx.full.min.js"></script>

<script>
// @ is an alias to /src
import XLSX from "xlsx";
import { dictionary } from "@/helpers";
import { excelTools } from "@/helpers";
import BookingFlow from "@/components/BookingFlow.vue";
import BookingAccount from "@/components/BookingAccount.vue";
import BookingPickupDelivery from "../components/BookingPickupDelivery.vue";
import BookingTimewindow from "../components/BookingTimewindow.vue";
import BookingVehicleType from "../components/BookingVehicleType.vue";
import BookingGoodsOverview from "../components/BookingGoodsOverview.vue";
import BookingExtraInfo from "../components/BookingExtraInfo.vue";
import BookingPrice from "../components/BookingPrice.vue";
import ConfirmSendDialog from "@/components/dialogs/QuestionDialog.vue";
import SendResultDialog from "@/components/dialogs/QuestionDialog.vue";
import ErrorDialog from "@/components/dialogs/QuestionDialog.vue";
import UploadBookingExcelDialog from "@/components/dialogs/FileChooserDialog.vue";
import ConfirmUploadBookingExcelDialog from "@/components/dialogs/QuestionDialog.vue";
import UploadBookingExcelErrorDialog from "@/components/dialogs/QuestionDialog.vue";

export default {
  name: "Booking",
  components: {
    BookingFlow,
    BookingAccount,
    BookingPickupDelivery,
    BookingTimewindow,
    BookingVehicleType,
    BookingGoodsOverview,
    BookingExtraInfo,
    BookingPrice,
    ConfirmSendDialog,
    SendResultDialog,
    ErrorDialog,
    UploadBookingExcelDialog,
    ConfirmUploadBookingExcelDialog,
    UploadBookingExcelErrorDialog
  },
  created() {
    const bookingType = this.$store.getters["user/bookingType"];
    this.allowUploadBookingExcel =
      bookingType == dictionary.constants.booking_types.distribution;
  },
  data: () => ({
    confirmSendDialog: false,
    sendResultDialog: false,
    sendResultTitle: "",
    sendResultText: "",
    showErrors: false,
    timeout: 0,
    excelJSON: [],
    allowUploadBookingExcel: false,
    showUploadBookingExcel: false,
    showUploadBookingExcelErrorDialog: false,
    uploadBookingExcelErrors: [],
    showConfirmUploadBookingExcelDialog: false,
    confirmUploadBookingExcelQuestion: ""
  }),
  computed: {
    valid: {
      get() {
        return this.$store.state.booking && this.$store.state.booking.valid;
      }
    },
    errors: {
      get() {
        return this.$store.state.booking.errors;
      }
    },
    booking: {
      get() {
        return this.$store.state.booking.data;
      }
    },
    loadProgress: {
      get() {
        return this.$store.state.booking.load_progress;
      }
    },
    displayExtraInfo: {
      get() {
        return this.$store.state.booking.display_extra_info;
      }
    }
  },
  watch: {
    displayExtraInfo: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.$nextTick(() => {
            this.$refs.form.validate();
          });
        }
      }
    },
    loadProgress: {
      handler(newVal, oldVal) {
        if (oldVal < 100 && newVal >= 100) {
          this.sendResultTitle = "Dine ordre er importeret!";
          this.sendResultText = "";
          this.sendResultDialog = true;
        }
      }
    },
    booking: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.$refs.form.validate();
        });
      }
    }
  },
  methods: {
    validate() {
      this.$store.dispatch("booking/validate");
      this.showErrors = !this.valid;
      this.confirmSendDialog = this.valid;
      this.$refs.form.validate();
    },
    downloadBookingExcelTemplate() {
      const filename = excelTools.booking_excel_template;

      this.$http({
        method: "get",
        url: "/files/" + filename,
        responseType: "arraybuffer"
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => console.log("error occured"));
    },

    async uploadBookingExcel(file) {
      // using SheetJS js-xlsx

      this.showUploadBookings = false;

      if (
        !(file instanceof Blob) ||
        file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.showUploadExcelBookingErrorDialog = true;
      } else {
        // use self or handleExcelBookings can not be caled from onload function
        const self = this;
        var reader = new FileReader();
        reader.onload = function(e) {
          // pre-process data
          var binary = "";
          var bytes = new Uint8Array(e.target.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }

          /* read workbook */
          var wb = XLSX.read(binary, { type: "binary" });

          /* grab first sheet */
          var wsname = wb.SheetNames[0];
          var ws = wb.Sheets[wsname];

          /* generate JSON */
          self.excelJSON = XLSX.utils.sheet_to_json(ws);

          self.validateBookingExcel();
        };

        reader.readAsArrayBuffer(file);
      }
    },
    async validateBookingExcel() {
      this.showUploadBookingExcel = false;

      const validationErrors = excelTools.validateBookingExcel(
        this.excelJSON,
        this.$store.state.user.activeUser
          ? this.$store.state.user.activeUser.accounts
          : []
      );

      if (validationErrors && validationErrors.length > 0) {
        this.uploadBookingExcelErrors = validationErrors;
        this.showUploadBookingExcelErrorDialog = true;
      } else {
        this.confirmUploadBookingExcelQuestion =
          "Vil du importere " + this.excelJSON.length + " ordre?";
        this.showConfirmUploadBookingExcelDialog = true;
      }
    },
    async handleBookingExcel() {
      this.showConfirmUploadBookingExcelDialog = false;

      const orders = excelTools.parseOrders(this.excelJSON);

      if (orders && orders.length > 0) {
        await this.$store
          .dispatch("booking/uploadBookingExcel", orders)
          .then(error => {
            this.sendResultTitle = "Noget gik galt!";
            this.sendResultText = error;
            this.sendResultDialog = true;
          });
      }

      this.excelJSON = [];
    },
    async submit() {
      this.confirmSendDialog = false;
      if (this.valid) {
        await this.$store.dispatch("booking/sendBooking").then(
          response => {
            this.$store.commit("booking/resetBooking");
            this.sendResultTitle = "Din booking er modtaget!";
            if (response.result.bookingno) {
              this.sendResultText = "Bookingnr. " + response.result.bookingno;
            }
          },
          error => {
            console.error(error);
            this.sendResultTitle = "Noget gik galt!";
            this.sendResultText =
              "Noget gik galt og din booking kunne ikke sendes.";
          }
        );
        this.sendResultDialog = true;
      }
    }
  }
};
</script>
